import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";
import { DinamicTitleService } from "../services/title/dinamic-title.service";

@Injectable()
export class PageTitleHelper extends TitleStrategy{
    constructor(
        private readonly routeTitle : Title,
        private titleService : DinamicTitleService
    ){
        super();
    }

    override updateTitle(routerState: RouterStateSnapshot): void {
        const routeTitle = this.buildTitle(routerState);
        if(routeTitle !== undefined){
            this.titleService.setTitle(routeTitle);
            
            this.routeTitle.setTitle(`Credito Carbono - ${routeTitle}`)
        }
    }

}